<template>
  <v-row class="pt-3">
    <v-col cols="12" sm="12" md="3" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อบริษัท</span>
      <v-select
        v-model="keywordCompanyName"
        :items="itemCompanyName"
        item-text="companyfullname"
        item-value="companyId"
        multiple
        outlined
        placeholder="ค้นหา ชื่อบริษัท"
        class="mt-0"
        dense
        @change="searchFilterData()"
      >
      <template v-slot:prepend-item v-if="itemCompanyName.length > 1">
          <v-list-item
            ripple
            @click="toggleCompany"
          >
            <v-list-item-action>
              <v-icon :color="keywordCompanyName.length > 0 ? 'indigo darken-4' : ''">
                {{ iconCompany }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                เลือกทั้งหมด
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-0"></v-divider>
        </template>
        <template #selection="{ item, index }">
          <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
            <span v-if="keywordCompanyName.length !== itemCompanyName.length" class="filter-chip_department" style="color: #3776E9">{{item.companyfullname}}</span>
            <span v-else-if="keywordCompanyName.length === itemCompanyName.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
          </v-chip>
          <v-chip  v-if="index === 1 && keywordCompanyName.length !== itemCompanyName.length" color="#EFF4FD !important" label small>
            <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordCompanyName.length - 1 }} เพิ่มเติม)</span>
          </v-chip>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">สายบังคับบัญชา</span>
      <v-select
        v-model="keywordSmall"
        :items="itemSmall"
        item-text="orgChartName"
        item-value="_id"
        multiple
        outlined
        placeholder="ค้นหา สายบังคับบัญชา"
        class="mt-0"
        dense
        @change="searchFilterData()"
      >
    <template v-slot:prepend-item v-if="itemSmall.length > 1">
      <v-list-item
        ripple
        @click="toggleOrgchart"
      >
        <v-list-item-action>
          <v-icon :color="keywordSmall.length > 0 ? 'indigo darken-4' : ''">
            {{ iconOrgchart }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            เลือกทั้งหมด
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-0"></v-divider>
    </template>
    <template #selection="{ item, index }">
      <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
        <span v-if="keywordSmall.length !== itemSmall.length" class="filter-chip_department" style="color: #3776E9">{{item.orgChartName}}</span>
        <span v-else-if="keywordSmall.length === itemSmall.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
      </v-chip>
      <v-chip  v-if="index === 1 && keywordSmall.length !== itemSmall.length" color="#EFF4FD !important" label small>
        <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordSmall.length - 1 }} เพิ่มเติม)</span>
      </v-chip>
    </template>
      </v-select>
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อเครือ</span>
      <v-select
        v-model="keywordGroupName"
        :items="itemGroupCompanyName"
        item-text="groupfullname"
        item-value="groupId"
        multiple
        outlined
        placeholder="ค้นหา ชื่อเครือ"
        class="mt-0"
        dense
        @change="searchFilterData()"
      >
      <template v-slot:prepend-item v-if="itemGroupCompanyName.length > 1">
        <v-list-item
          ripple
          @click="toggleGroupCompany"
        >
          <v-list-item-action>
            <v-icon :color="keywordGroupName.length > 0 ? 'indigo darken-4' : ''">
              {{ iconGroup }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              เลือกทั้งหมด
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-0"></v-divider>
      </template>
      <template #selection="{ item, index }">
        <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
          <span v-if="keywordGroupName.length !== itemGroupCompanyName.length" class="filter-chip_department" style="color: #3776E9">{{item.groupfullname}}</span>
          <span v-else-if="keywordGroupName.length === itemGroupCompanyName.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
        </v-chip>
        <v-chip  v-if="index === 1 && keywordGroupName.length !== itemGroupCompanyName.length" color="#EFF4FD !important" label small>
          <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordGroupName.length - 1 }} เพิ่มเติม)</span>
        </v-chip>
      </template>
    </v-select>
  </v-col>
    <!-- <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 1.5%;">
      <v-row class="pl-3 pr-3" style="margin-bottom: 0px;">
        <v-btn outlined color="primary" class="mr-5" style="min-height: 30px;" @click="searchFilterData()">ค้นหา</v-btn>
        <v-btn outlined color="primary" class="" style="min-height: 30px;" @click="resetFilterData()">ล้าง</v-btn>
      </v-row>
    </v-col> -->
    <!-- <v-col cols="12" lg="4" md="6" sm="6" class="pt-0 pb-0 d-flex align-end">
      <v-row class="pl-3 pr-3" style="margin-bottom: 14px;">
        <v-btn class="btn-search-dep mr-5" style="min-height: 38px;" @click="searchFilterData()">ค้นหา</v-btn>
        <v-btn class="btn-reset-dep" style="min-height: 38px;" @click="resetFilterData()">ล้างข้อมูล</v-btn>
      </v-row>
    </v-col> -->
    <v-col cols="12" sm="12" md="3" lg="3" class="pt-0 pb-0 d-flex align-center justify-end mt-0 mr-0">
      <v-btn
        outlined
        class="button-color ra-button-role-company"
        dark
        @click="gotocreate('บริษัท')"
      >
        <v-icon left dark color="#fff" size="14px" class="">mdi-plus</v-icon>
        <span class="ra-text-in-button-role-company">
          เพิ่มสิทธิ์การใช้งาน
        </span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  name: 'filter-workgroup',
  data () {
    return {
      keywordSmall: [],
      keywordLineWorkName: '',
      keywordCompanyName: [],
      keywordGroupName: [],
      chkCompanyName: '',
      chkGroupName: '',
      chkOrgchart: '',
      memoryCompanyName: [],
      memoryGroupName: [],
      memoryOrgchart: [],
      filterData: {
        companyShortName: [],
        managementName: '',
        managementHeader: '',
        userName: '',
        userPosition: ''
      },
      itemSmall: ['INET', 'OGS'],
      itemLineWorkName: [],
      itemCompanyName: [],
      itemGroupCompanyName: [],
      itemsSmallDep: [{
        id: 0,
        value: 0,
        label: 'INET'
      }, {
        id: 1,
        value: 1,
        label: 'MANDALA'
      }]
    }
  },
  computed: {
    selectAllCompany () {
      return this.keywordCompanyName.length === this.itemCompanyName.length
    },
    selectSomeCompany () {
      return this.keywordCompanyName.length > 0 && !this.selectAllCompany
    },
    iconCompany () {
      if (this.selectAllCompany) return 'mdi-close-box'
      if (this.selectSomeCompany) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAllGroupCompany () {
      return this.keywordGroupName.length === this.itemGroupCompanyName.length
    },
    selectSomeGroupCompany () {
      return this.keywordGroupName.length > 0 && !this.selectAllGroupCompany
    },
    iconGroup () {
      if (this.selectAllGroupCompany) return 'mdi-close-box'
      if (this.selectSomeGroupCompany) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAllOrgchart () {
      return this.keywordSmall.length === this.itemSmall.length
    },
    selectSomeOrgchart () {
      return this.keywordSmall.length > 0 && !this.selectAllOrgchart
    },
    iconOrgchart () {
      if (this.selectAllOrgchart) return 'mdi-close-box'
      if (this.selectSomeOrgchart) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  watch: {
    keywordSmall: function (val) {
      if (val.length) {
        this.filterData.companyShortName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    },
    keywordLineWorkName: function (val) {
      if (val.length) {
        this.filterData.managementName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    }
  },
  beforeDestroy () {
    EventBus.$off('selectCompanyRole')
    EventBus.$off('resetFilterRole')
  },
  mounted () {
    EventBus.$on('getPosition', this.getSelectData)
    EventBus.$on('selectCompanyRole', this.getSelectValue)
    EventBus.$on('resetFilterRole', this.resetFilterData)
  },
  methods: {
    toggleCompany () {
      this.$nextTick(() => {
        if (this.selectAllCompany) {
          this.chkCompanyName = false
          this.keywordCompanyName = []
        } else {
          this.chkCompanyName = true
          this.keywordCompanyName = this.itemCompanyName.slice()
          for (let index = 0; index < this.keywordCompanyName.length; index++) {
            this.memoryCompanyName = []
          }
          this.searchFilterData()
        }
      })
    },
    toggleGroupCompany () {
      this.$nextTick(() => {
        if (this.selectAllGroupCompany) {
          this.chkGroupName = false
          this.keywordGroupName = []
        } else {
          this.chkGroupName = true
          this.keywordGroupName = this.itemGroupCompanyName.slice()
          for (let index = 0; index < this.keywordGroupName.length; index++) {
            this.memoryGroupName = []
          }
          this.searchFilterData()
        }
      })
    },
    toggleOrgchart () {
      this.$nextTick(() => {
        if (this.selectAllOrgchart) {
          this.chkOrgchart = false
          this.keywordSmall = []
        } else {
          this.chkOrgchart = true
          this.keywordSmall = this.itemSmall.slice()
          for (let index = 0; index < this.keywordSmall.length; index++) {
            this.memoryOrgchart = []
          }
          this.searchFilterData()
        }
      })
    },
    getSelectValue (data) {
      // const temp = []
      // data.result.company.map((el, index) => {
      //   temp.push({
      //     fullnameCompany: el.companyShortNameTh + '-' + el.companyFullNameTh,
      //     no: index + 1,
      //     ...el
      //   })
      // })
      // console.log('temp', temp)
      this.itemSmall = data.orgchart
      this.itemCompanyName = data.company
      this.itemGroupCompanyName = data.group
    },
    getSelectData (data) {
      // this.itemSmall = data.companyShortName
      // this.itemCompanyName = data.companyName
      // this.itemGroupCompanyName = data.groupCompanyName
    },
    resetFilterData () {
      this.keywordSmall = []
      this.keywordLineWorkName = []
      this.keywordCompanyName = []
      this.filterData = {
        groupId: [],
        orgchartId: [],
        companyName: [],
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterCompantyRole', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        groupId: this.selectAllGroupCompany === true ? this.memoryGroupName : this.keywordGroupName,
        orgchartId: this.selectAllOrgchart === true ? this.memoryOrgchart : this.keywordSmall,
        companyName: this.selectAllCompany === true ? this.memoryCompanyName : this.keywordCompanyName,
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterCompantyRole', this.filterData)
    },
    gotocreate (title) {
      this.$router.push('managerolecompany/create')
    }
  }
}
</script>

<style scoped>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-button-role-company {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 9px 24px; */

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button-role-company {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
